import React, { useState } from 'react';
import { X, Check, HelpCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";

const plans = [
  {
    name: "Basic",
    price: { monthly: 49, annual: 470 },
    features: ["Basic ESG reporting", "Carbon footprint calculator", "Limited AI insights"],
  },
  {
    name: "Pro",
    price: { monthly: 99, annual: 950 },
    features: ["Advanced ESG reporting", "Supply chain analysis", "Full AI insights and predictions", "Stakeholder engagement tools"],
  },
  {
    name: "Enterprise",
    price: { monthly: 299, annual: 2870 },
    features: ["Custom ESG solutions", "Dedicated account manager", "API access", "Advanced data integration", "Custom AI model training"],
  }
];

const UpgradeModal = ({ isOpen, onClose, currentPlan }) => {
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] w-[90vw] max-h-[90vh] overflow-y-auto fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6">
        <div
          onClick={onClose}
          className="absolute top-2 right-2 p-2 cursor-pointer hover:bg-gray-100 rounded-full transition-colors duration-200"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </div>

        <DialogHeader>
          <DialogTitle className="text-2xl font-bold mb-2">Upgrade Your Plan</DialogTitle>
          <DialogDescription className="text-gray-600">
            Choose the plan that best fits your ESG management needs
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-end items-center space-x-2 my-4">
          <span className={`text-sm ${!isAnnual ? 'font-bold' : ''}`}>Monthly</span>
          <Switch checked={isAnnual} onCheckedChange={setIsAnnual} />
          <span className={`text-sm ${isAnnual ? 'font-bold' : ''}`}>Annual</span>
          <div className="relative group">
            <HelpCircle className="h-4 w-4 text-gray-400 cursor-help" />
            <div className="absolute bottom-full mb-2 right-0 bg-gray-800 text-white text-xs p-2 rounded shadow-lg invisible group-hover:visible transition-all duration-200 w-48">
              Save up to 20% with annual billing
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {plans.map((plan) => (
            <div key={plan.name} className={`border rounded-lg p-4 ${currentPlan === plan.name ? 'border-primary border-2' : 'border-gray-200'}`}>
              <h3 className="font-bold text-lg mb-2">{plan.name}</h3>
              <p className="text-2xl font-bold mb-4">
                ${isAnnual ? plan.price.annual : plan.price.monthly}
                <span className="text-sm font-normal text-gray-600">/{isAnnual ? 'year' : 'month'}</span>
              </p>
              <ul className="space-y-2 mb-4">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    <Check className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button 
                className="w-full" 
                variant={currentPlan === plan.name ? "outline" : "default"}
                onClick={() => {
                  if (currentPlan !== plan.name) {
                    console.log(`Upgrading to ${plan.name} plan`);
                    // Implement your upgrade logic here
                  }
                }}
              >
                {currentPlan === plan.name ? 'Current Plan' : 'Upgrade'}
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;